export function translateNumber(number) {
    if (!number) return ''
    let result = number.toString().replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[d]).replace(/,/g, '،');
    return result;
}